import type { MapData } from '../engine/types.js';
import raw from './standard-map.json' with { type: 'json' };
import aliases from '../engine/aliases.json' with { type: 'json' };

/** Standard Diplomacy map. The graph is generated by `src/data/build-standard-map.py`. */
export const STANDARD_MAP: MapData = {
  ...(raw as unknown as Pick<MapData, 'provinces' | 'lifeAdjacency' | 'startingUnits' | 'startingCenters'>),
  id: 'standard',
  name: 'Standard',
  powers: ['AUSTRIA', 'ENGLAND', 'FRANCE', 'GERMANY', 'ITALY', 'RUSSIA', 'TURKEY'],
  powerWords: {
    austria: 'AUSTRIA',
    austrian: 'AUSTRIA',
    'austria-hungary': 'AUSTRIA',
    england: 'ENGLAND',
    english: 'ENGLAND',
    britain: 'ENGLAND',
    france: 'FRANCE',
    french: 'FRANCE',
    germany: 'GERMANY',
    german: 'GERMANY',
    italy: 'ITALY',
    italian: 'ITALY',
    russia: 'RUSSIA',
    russian: 'RUSSIA',
    turkey: 'TURKEY',
    turkish: 'TURKEY',
  },
  aliases: aliases as Record<string, string[]>,
  startYear: 1901,
  soloCentres: 18,
};

export default STANDARD_MAP;
